"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TypeHelper = /** @class */ (function () {
    function TypeHelper() {
    }
    TypeHelper.isHigherVersion = function (latestVersion, currentVersion) {
        var latestSubVersions = latestVersion.split('.');
        var currentSubVersions = currentVersion.split('.');
        if (parseInt(latestSubVersions[0]) < parseInt(currentSubVersions[0])) {
            return true;
        }
        if (parseInt(latestSubVersions[0]) > parseInt(currentSubVersions[0])) {
            return false;
        }
        // Both major versions are equal
        if (parseInt(latestSubVersions[1]) < parseInt(currentSubVersions[1])) {
            return true;
        }
        if (parseInt(latestSubVersions[1]) > parseInt(currentSubVersions[1])) {
            return false;
        }
        // Both minor versions are equal
        if (parseInt(latestSubVersions[2]) < parseInt(currentSubVersions[2])) {
            return true;
        }
        if (parseInt(latestSubVersions[2]) > parseInt(currentSubVersions[2])) {
            return false;
        }
        return false; // Both versions are equal
    };
    return TypeHelper;
}());
exports.TypeHelper = TypeHelper;
//# sourceMappingURL=TypeHelper.js.map